(ns kyber.lib.pdftron.toolbar
  (:require [reagent.core :as reagent]
            [re-frame.core :as re-frame]
            [cljs-bean.core :refer [->js]]

            [kyber.styles.core :refer [gs]]
            [learner.utils :as u]))

;; ;;;;;;;;;;;;;;;;;;;;;;
;; Constants
;; ;;;;;;;;;;;;;;;;;;;;;;

(def ^:private pdftron-navbar-height 47)

;; ;;;;;;;;;;;;;;;;;;;;;;
;; Icons
;; ;;;;;;;;;;;;;;;;;;;;;;

(def pan-icon
  (str "M369.4 119.1V96.3c0-42.8-42.8-72.8-82.3-56.5-19.8-54.2-94.4-52.2-112.5."
       "8-38.4-15.8-81.8 12.8-81.8 55.9v145.7c-20.3-13.7-47.6-13.9-68.4 1.5-26."
       "6 19.6-32.4 57.1-13.1 83.9l125 174.4c4.5 6.3 11.8 10 19.5 10H388c11.2 "
       "0 20.9-7.7 23.4-18.6l31.4-135.6c3.4-14.8 5.2-30 5.2-45.3V176.2c0-41.5-"
       "40.6-70.1-78.6-57.1zM416 312.5c0 12.8-1.5 25.6-4.4 38l-30 129.4H159.9l"
       "-122.6-171c-9-12.6-6.3-30.4 6.1-39.5 12.3-9.1 29.6-6.4 38.6 6.2l28.3 "
       "39.4c4.5 6.3 14.5 3.1 14.5-4.7V96.5c0-38 55.4-36.9 55.4.7V256c0 4.4 3"
       ".6 8 8 8h7.1c4.4 0 8-3.6 8-8V60.2c0-38 55.4-36.9 55.4.7v195c0 4.4 3."
       "6 8 8 8h7.1c4.4 0 8-3.6 8-8V95.6c0-38 55.4-36.9 55.4.7V256c0 4.4 3.6 "
       "8 8 8h7.1c4.4 0 8-3.6 8-8v-79c0-37.6 55.4-38.8 55.4-.7v136.2z"))

(def text-select-icon
  (str "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 "
       "23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129."
       "136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 "
       "19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-"
       "12.5 31.141z"))

(def comment-icon
  (str "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 "
       "12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-"
       "35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v"
       "-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 "
       "16v288z"))

(def search-minus-icon
  (str "M312 196v24c0 6.6-5.4 12-12 12H116c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12"
       " 12-12h184c6.6 0 12 5.4 12 12zm196.5 289.9l-22.6 22.6c-4.7 4.7-12.3 4.7"
       "-17 0L347.5 387.1c-2.3-2.3-3.5-5.3-3.5-8.5v-13.2c-36.5 31.5-84 50.6-13"
       "6 50.6C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 52-19.1 "
       "99.5-50.6 136h13.2c3.2 0 6.2 1.3 8.5 3.5l121.4 121.4c4.7 4.7 4.7 12.3 "
       "0 17zM368 208c0-88.4-71.6-160-160-160S48 119.6 48 208s71.6 160 160 160 "
       "160-71.6 160-160z"))

(def search-plus-icon
  (str "M312 196v24c0 6.6-5.4 12-12 12h-68v68c0 6.6-5.4 12-12 12h-24c-6.6 0-12-"
       "5.4-12-12v-68h-68c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h68v-68c0-"
       "6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v68h68c6.6 0 12 5.4 12 12zm196.5"
       " 289.9l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L347.5 387.1c-2.3-2.3-3.5-5.3-"
       "3.5-8.5v-13.2c-36.5 31.5-84 50.6-136 50.6C93.1 416 0 322.9 0 208S93.1 "
       "0 208 0s208 93.1 208 208c0 52-19.1 99.5-50.6 136h13.2c3.2 0 6.2 1.3 8."
       "5 3.5l121.4 121.4c4.7 4.7 4.7 12.3 0 17zM368 208c0-88.4-71.6-160-160-"
       "160S48 119.6 48 208s71.6 160 160 160 160-71.6 160-160z"))

(def search-icon
  (str "M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-"
       "84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 "
       "99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 "
       "4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160"
       "-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"))

(def thumbnail-drawer
  (str "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 "
       "0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM232 432H54a6 6 0 0 1-6-6V1"
       "12h184v320zm226 0H280V112h184v314a6 6 0 0 1-6 6z"))

(def square-icon
  (str "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 "
       "48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8"
       ".8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352z"))

(def home-icon
  (str "M557.1 240.7L512 203.8V104c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v60.5L3"
       "13.4 41.1c-14.7-12.1-36-12.1-50.7 0L18.9 240.7c-3.4 2.8-3.9 7.8-1.1 11"
       ".3l20.3 24.8c2.8 3.4 7.8 3.9 11.3 1.1l14.7-12V464c0 8.8 7.2 16 16 16h1"
       "68c4.4 0 8-3.6 8-8V344h64v128c0 4.4 3.6 8 8 8h168c8.8 0 16-7.2 16-16V2"
       "65.8l14.7 12c3.4 2.8 8.5 2.3 11.3-1.1l20.3-24.8c2.6-3.4 2.1-8.4-1.3-11"
       ".2zM464 432h-96V304c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8v128h-96V226.5"
       "l170.9-140c2.9-2.4 7.2-2.4 10.1 0l170.9 140V432z"))

;; ;;;;;;;;;;;;;;;;;;;;;;
;; Helpers
;; ;;;;;;;;;;;;;;;;;;;;;;

(defn- reactify
  "Reactify the tool"
  [component]
  (fn []
    (reagent/create-element
     (reagent/reactify-component component))))

(defn- on-tool-select
  "Triggers re-frame tool-select event"
  [tool-name options]
  (re-frame/dispatch [:pdftron-viewer/on-tool-select
                      {:options options
                       :tool-name tool-name}]))

(defn- render-tool-bar-icon
  [{:keys [options]}]
  (let [active-tool (re-frame/subscribe
                     [:pdftron-viewer/get-active-tool options])]
    (fn [{:keys [path view-box on-click tool-name]}]
      (let [active (and (= @active-tool tool-name)
                        (some? tool-name))]
        [:button {:class ["button-core" (if (true? active)
                                          "button-active"
                                          "button-inactive")]
                  
                  ;; The on-click logic below selects the default tool if the current tool is clicked
                  ;; when it is already selected.  This deselects it, toggling it off
                  :on-click #(if (true? active)
                               (on-tool-select :AnnotationEdit options)
                               (on-click))
                  :title (cond 
                           (= tool-name :TextSelect) "Select Text"
                           (= tool-name :AnnotationCreateSticky) "Create a Sticky Annotation"
                           :else tool-name)
                  :id tool-name}
         [:svg {:xmlns "http://www.w3.org/2000/svg"
                :ariaHidden "true"
                :viewBox view-box
                :class "button-svg-core"}
          [:path
           {:fill "currentColor"
            :d path}]]]))))

;; ;;;;;;;;;;;;;;;;;;;;;;
;; Elements
;; ;;;;;;;;;;;;;;;;;;;;;;

(defn divider [_]
  {:type "divider"
   :hidden ["mobile"]})

(defn spacer [_]
  {:type "spacer"})

(defn custom-toggle-search [options]
  {:type "customElement"
   :hidden []
   :dataElement "kyber--search-toggle"
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :on-click #(re-frame/dispatch
                    [:pdftron-viewer/toggle-search options])
        :path search-icon
        :view-box "0 0 512 512"}]))})

(defn custom-home [options]
  (let [{:keys [curriculum-uuid provider-homepage-url]} options]
    {:type "customElement"
     :hidden []
     :dataElement "kyber--home"
     :render
     (reactify
      (fn [_]
        [render-tool-bar-icon
         {:options options
          :on-click #(if (some? provider-homepage-url)
                       (set! (.-location js/document)
                             provider-homepage-url)
                       (re-frame/dispatch
                        [:router/nav-to
                         (u/->learner-route
                          {:curriculum-uuid curriculum-uuid})]))
          :path home-icon
          :view-box "30 30 516 452"}]))}))

(defn custom-toggle-thumbnails [options]
  {:type "customElement"
   :dataElement "kyber--thumbnail-toggle"
   :hidden []
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :on-click #(re-frame/dispatch
                    [:pdftron-viewer/toggle-thumbnails options])
        :path thumbnail-drawer
        :view-box "0 0 512 512"}]))})

(defn custom-zoom-in [options]
  {:type "customElement"
   :hidden []
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :on-click #(re-frame/dispatch
                    [:pdftron-viewer/zoom-in options])
        :path search-plus-icon
        :view-box "0 0 512 512"}]))})

(defn custom-zoom-out [options]
  {:type "customElement"
   :hidden []
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :on-click #(re-frame/dispatch
                    [:pdftron-viewer/zoom-out options])
        :path search-minus-icon
        :view-box "0 0 512 512"}]))})

(defn custom-create-free-text-annotation [options]
  {:type "customElement"
   :hidden []
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :tool-name :AnnotationCreateSticky
        :on-click #(on-tool-select :AnnotationCreateSticky options)
        :path comment-icon
        :view-box "0 0 512 512"}]))})

(defn custom-create-rect-annotation [options]
  {:type "customElement"
   :hidden []
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :tool-name :AnnotationCreateRectangle
        :on-click #(on-tool-select :AnnotationCreateRectangle options)
        :path square-icon
        :view-box "0 0 448 512"}]))})

(defn custom-pan-tool [options]
  {:type "customElement"
   :hidden []
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :tool-name :Pan
        :on-click #(on-tool-select :Pan options)
        :path pan-icon
        :view-box "0 0 448 512"}]))})

(defn custom-text-select-tool [options]
  {:type "customElement"
   :hidden []
   :render
   (reactify
    (fn [_]
      [render-tool-bar-icon
       {:options options
        :tool-name :TextSelect
        :on-click #(on-tool-select :TextSelect options)
        :path text-select-icon
        :view-box "0 0 320 512"}]))})

(defn custom-logo [{:keys [logo]}]
  {:type "customElement"
   :render
   (reactify
    (fn [_]
      (when (some? logo)
        [:img {:src logo
               :style {:padding-left (gs [:spacing :p20])
                       :padding-right (gs [:spacing :p20])
                       :max-height (str (- pdftron-navbar-height 2)
                                        "px")}}])))})

;; ;;;;;;;;;;;;;;;;;;;;;;
;; Renderer
;; ;;;;;;;;;;;;;;;;;;;;;;

(defn set-default-header-tools
  "Depending on the run time, (learner or admin) some tools may not be enabled
  by default."
  [{:keys [viewer-key tools] :as options}
   {:keys [set-header-items disable-elements]}]
  (set-header-items
   (fn [header-api]
     (js-invoke header-api "update"
                (->js (map #(% options) tools)))

     ;; Prevented until completion threshold has been pased for the
     ;; main activity
     (when (= viewer-key :main-activity)
       (disable-elements #js ["kyber--thumbnail-toggle"])))))
